import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { TextFieldWithAddon } from '../../../ui/FormElement';

function MonthlyDiscount(props) {
  const { isDisabled, ...rest } = props;

  const {
    values: { monthly_discount_enable },
    setFieldValue,
  } = useFormikContext();

  useEffect(() => {
    if (!monthly_discount_enable) {
      setFieldValue('monthly_discount', '');
    }
  }, [monthly_discount_enable]);

  return (
    <TextFieldWithAddon
      disabled={!monthly_discount_enable || isDisabled}
      name="monthly_discount"
      type="number"
      addon="%"
      min="0"
      step="0.01"
      pattern="d+(.d{1,2})?"
      {...rest}
    />
  );
}

export default MonthlyDiscount;
